import { Injectable, signal } from '@angular/core';
import { UserService } from './user.service';
import { User } from '../models/user';
import { catchError, map, Observable, of, switchMap, throwError } from 'rxjs';
import { Utils } from './utils.service';
import { Trainer } from '../models/trainer';
import { AuthRequest } from '../models/authRequest';


@Injectable()
export class UserDataService {

  constructor(
    private userService: UserService,
    private utils: Utils,
  ) {
    this.refreshTrainers();
  }

  user = signal<User | null>(null);
  trainers = signal<Array<Trainer>>([]);

  public auth(auth: AuthRequest): Observable<User> {
    return this.userService.auth(auth).pipe(
      switchMap(token => {
        localStorage.setItem('token', token?.accessToken ?? '');
        return this.checkUser();
      })
    );
  }

  public checkUser(): Observable<User> {
    const token = localStorage.getItem('token');
    if (token == null) {
      return throwError(() => {
        return {
          status: 401
        }
      });
    }

    const user = this.user();
    if (user) {
      return of(user);
    }

    return this.userService.getUser().pipe(
      map(user => {
        this.user.set(user);
        return user;
      }),
      catchError((error, caught) => {
        if (error.status == 401) {
          localStorage.removeItem('token');
        }
        return throwError(() => error);
      })
    );
  }

  public logout() {
    this.user.set(null);
    localStorage.removeItem('token');
  }

  private refreshTrainers() {
    this.utils.getTrainers().subscribe({
      next: trainers => {
        const sorted = trainers.trainers.sort((t1, t2) => {
          if (t1.name.toLowerCase() < t2.name.toLowerCase()) {
            return -1;
          } else {
            return 1;
          }
        });
        this.trainers.set(sorted);
      }
    });
  }
}
